import styled from 'styled-components';
import themeToken from '@lib/theme/tokens/index';
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link)`
  color: ${themeToken['secondary-chrysler-blue-600']};
  font-weight: 600;
`;
